import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { supervisoryDashboard } from "../../../api/service";
import { SupervisoryDashboardInfo } from "../../../api/supervisory/supervisory-dashboard.model";

export interface ISupervisoryDashboardSlice {
    supervisoryDashboard: SupervisoryDashboardInfo | null;
    loading: boolean;
    error: any;
    status: string;
}

const INITIAL_STATE = {
    supervisoryDashboard: null,
    loading: false,
    error: null,
    status: "idle",
} as ISupervisoryDashboardSlice;

export const getSupervisoryDashboard = createAsyncThunk(
    "supervisoryDashboard/getSupervisoryDashboard",
    supervisoryDashboard.getSupervisoryDashboard
);

const supervisoryDashboardSlice = createSlice({
    name: "supervisoryDashboard",
    initialState: INITIAL_STATE,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSupervisoryDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.status = "loading";
            })
            .addCase(getSupervisoryDashboard.fulfilled, (state, action) => {
                state.supervisoryDashboard = action.payload;
                state.loading = false;
                state.error = null;
                state.status = "succeeded";
            })
            .addCase(getSupervisoryDashboard.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.status = "failed";
            });
    },
});

export const { reducer: supervisoryDashboardReducer } = supervisoryDashboardSlice;